import { action } from 'satcheljs';

export interface ResetSxSViewStoreActionMessage {
    actionSource: string;
}
const defaultExport: (actionSource: string) => ResetSxSViewStoreActionMessage = action(
    'resetSxSViewStore',
    (actionSource: string): ResetSxSViewStoreActionMessage => ({ actionSource })
);
export default defaultExport;
